<div class="web-view-container">
	<div class="main">
		<app-kamona-carousel [carouselItems]="carouselItems"
							 [carouselTemplateRef]="carouselTemplateRef">
			<ng-template #carouselTemplateRef let-item let-position="idx">
				<div class="splash-screen-carousel">
					<div class="item-img flex justify-center">
						<img src="{{item?.imgLink}}">
					</div>
					<div
						class="carousel-content">
						<div class="title">
							<div>{{item?.title}}</div>
							<div *ngIf="item?.titleII">
								{{item?.titleII}}
							</div>
						</div>
						<div class="description">
							{{item?.description}}
						</div>
					</div>
				</div>
			</ng-template>
		</app-kamona-carousel>
	</div>
	<div class="footer">
		<div (click)="signUp()" class="sign-up">
			Sign Up
		</div>
		<div (click)="route('/login')" class="login">
			Login
		</div>
	</div>
</div>


